// Same dev-build gate DebugEnvStore fails closed on — a debug override must never be honoured in a
// production build, whatever ends up in localStorage.
const DEV_BUILD_MODES = ['local-dev', 'development'];

export function isDevBuild(): boolean {
  return DEV_BUILD_MODES.includes(import.meta.env.MODE);
}

/**
 * Reads a dev-only localStorage override. Returns null outside a local/dev build, when the key is
 * unset, and when storage throws (private mode, hardened browser) — so every caller's non-override
 * path is the production path.
 */
export function readDevOverride(key: string): string | null {
  if (!isDevBuild()) {
    return null;
  }

  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
